import useStudents from '../hooks/students.hook';
import StudentSearch from '../components/molecules/StudentSearch';
import StudentTable from '../components/organisms/StudentTable';
import PageHeader from '../components/molecules/PageHeader';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from '@mui/material/Pagination';

const Students = () => {
  const {
    isFetching,
    setSearchString,
    data,
    noResults,
    page,
    openDialog,
    handleClose,
    handlePageChange,
  } = useStudents();

  return (
    <div>
      <PageHeader
        testid='student-title'
        RightSideComponent={StudentSearch}
        setSearchString={setSearchString}
      >
        Students
      </PageHeader>
      <div className='spacer'></div>
      <div>
        {<StudentTable students={data?.students} noResults={noResults} />}
      </div>
      <div className='flex justify-center p-6'>
        <Pagination
          count={data?.totalPage}
          color='primary'
          page={page}
          onChange={handlePageChange}
        />
      </div>

      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={!!isFetching}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  );
};

export default Students;
